module.exports = __webpack_public_path__ + "static/media/protection.ac26bb1e.svg";